module.exports = __webpack_public_path__ + "img/analytic-geometry.cdb4c520.png";